const doc = [({"da":({"js":({"admin":({"teams":({"index":({"the_team_was_deleted":"Holdet blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;